import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router/router'
import store from './store/store'
import axios from 'axios'

Vue.config.productionTip = false

//to be able to do stuff all over the app
export const appBus = new Vue()

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.headers.put['Content-Type'] = 'application/json;charset=UTF-8'

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
